export default __webpack_public_path__ + "static/media/Magnum1.73393e37.jpeg";